// Corner radii — exact values from theme.css --r-* variables.
// Buttons/inputs use r2; cards r3; modals r4; chips/pills full.
export const Radii = {
  r1: 3,
  r2: 5,
  r3: 8,
  r4: 12,
  r5: 16,
  full: 999,
} as const;
